import RadioButton from '../Common/RadioButton';

const RadioButtonWrapper = objProps => {
  return <RadioButton {...objProps.field} {...objProps} />;
};

export default RadioButtonWrapper;
